export default __webpack_public_path__ + "static/media/arrow-left.5fe75e6c.svg";